"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersApi = void 0;
var runtime = __importStar(require("../runtime"));
var ChangePhoneDto_1 = require("../models/ChangePhoneDto");
var ChangePhoneResponseDto_1 = require("../models/ChangePhoneResponseDto");
var CheckPhoneChangeDto_1 = require("../models/CheckPhoneChangeDto");
var CheckPhoneChangeResponseDto_1 = require("../models/CheckPhoneChangeResponseDto");
var ConfirmEmailChangeDto_1 = require("../models/ConfirmEmailChangeDto");
var ConfirmEmailChangeResponseDto_1 = require("../models/ConfirmEmailChangeResponseDto");
var DigestTimesResponseDto_1 = require("../models/DigestTimesResponseDto");
var LanguageOptionsDto_1 = require("../models/LanguageOptionsDto");
var RequestEmailChangeDto_1 = require("../models/RequestEmailChangeDto");
var RequestEmailChangeResponseDto_1 = require("../models/RequestEmailChangeResponseDto");
var SelectedLanguageDto_1 = require("../models/SelectedLanguageDto");
var TimezoneListDto_1 = require("../models/TimezoneListDto");
var UpdateDigestTimesDto_1 = require("../models/UpdateDigestTimesDto");
var UpdateLanguageDto_1 = require("../models/UpdateLanguageDto");
var UpdateLocationDto_1 = require("../models/UpdateLocationDto");
var UpdateLocationResponseDto_1 = require("../models/UpdateLocationResponseDto");
var UpdateTimezoneDto_1 = require("../models/UpdateTimezoneDto");
var UpdateTimezoneResponseDto_1 = require("../models/UpdateTimezoneResponseDto");
var UpdateUserDto_1 = require("../models/UpdateUserDto");
/**
 *
 */
var UsersApi = /** @class */ (function (_super) {
    __extends(UsersApi, _super);
    function UsersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates request options for digestTimeControllerListV1 without sending the request
     */
    UsersApi.prototype.digestTimeControllerListV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/digest-times";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Returns every published slot, grouped by min_tier (FREE, PRO & CHAMPION, CHAMPION EXCLUSIVE), together with an `unlocked` flag per group derived from the caller plan tier. The user current selection is echoed so the UI can render check marks without a second call.
     * List digest slots grouped by tier
     */
    UsersApi.prototype.digestTimeControllerListV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestTimeControllerListV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, DigestTimesResponseDto_1.DigestTimesResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns every published slot, grouped by min_tier (FREE, PRO & CHAMPION, CHAMPION EXCLUSIVE), together with an `unlocked` flag per group derived from the caller plan tier. The user current selection is echoed so the UI can render check marks without a second call.
     * List digest slots grouped by tier
     */
    UsersApi.prototype.digestTimeControllerListV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestTimeControllerListV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for digestTimeControllerUpdateV1 without sending the request
     */
    UsersApi.prototype.digestTimeControllerUpdateV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['updateDigestTimesDto'] == null) {
                            throw new runtime.RequiredError('updateDigestTimesDto', 'Required parameter "updateDigestTimesDto" was null or undefined when calling digestTimeControllerUpdateV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/digest-times";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, UpdateDigestTimesDto_1.UpdateDigestTimesDtoToJSON)(requestParameters['updateDigestTimesDto']),
                            }];
                }
            });
        });
    };
    /**
     * Sets the primary morning slot (Free 07:00 or Champion 06:00/08:00/09:00/10:00) and optionally the Champion evening slot. Server-side enforces `slot.min_tier <= user.tier` and morning/evening period; passing `eveningId` from a non-Champion caller returns 403.
     * Update the digest delivery slot(s)
     */
    UsersApi.prototype.digestTimeControllerUpdateV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestTimeControllerUpdateV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, DigestTimesResponseDto_1.DigestTimesResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Sets the primary morning slot (Free 07:00 or Champion 06:00/08:00/09:00/10:00) and optionally the Champion evening slot. Server-side enforces `slot.min_tier <= user.tier` and morning/evening period; passing `eveningId` from a non-Champion caller returns 403.
     * Update the digest delivery slot(s)
     */
    UsersApi.prototype.digestTimeControllerUpdateV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.digestTimeControllerUpdateV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for emailConfirmControllerConfirmV1 without sending the request
     */
    UsersApi.prototype.emailConfirmControllerConfirmV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['confirmEmailChangeDto'] == null) {
                            throw new runtime.RequiredError('confirmEmailChangeDto', 'Required parameter "confirmEmailChangeDto" was null or undefined when calling emailConfirmControllerConfirmV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/email/confirm";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, ConfirmEmailChangeDto_1.ConfirmEmailChangeDtoToJSON)(requestParameters['confirmEmailChangeDto']),
                            }];
                }
            });
        });
    };
    /**
     * Constant-time-compares the submitted OTP against the hashed code stored in `otp_challenges`. Enforces a 10-minute TTL and a 5-attempt cap. On success, swaps `email <- pending_email`, sets `is_email_verified = true`, bumps `token_version` to invalidate any outstanding refresh tokens, and returns a fresh JWT pair together with the updated profile.
     * Confirm an email change with the OTP
     */
    UsersApi.prototype.emailConfirmControllerConfirmV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.emailConfirmControllerConfirmV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, ConfirmEmailChangeResponseDto_1.ConfirmEmailChangeResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Constant-time-compares the submitted OTP against the hashed code stored in `otp_challenges`. Enforces a 10-minute TTL and a 5-attempt cap. On success, swaps `email <- pending_email`, sets `is_email_verified = true`, bumps `token_version` to invalidate any outstanding refresh tokens, and returns a fresh JWT pair together with the updated profile.
     * Confirm an email change with the OTP
     */
    UsersApi.prototype.emailConfirmControllerConfirmV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.emailConfirmControllerConfirmV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for emailRequestChangeControllerRequestChangeV1 without sending the request
     */
    UsersApi.prototype.emailRequestChangeControllerRequestChangeV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['requestEmailChangeDto'] == null) {
                            throw new runtime.RequiredError('requestEmailChangeDto', 'Required parameter "requestEmailChangeDto" was null or undefined when calling emailRequestChangeControllerRequestChangeV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/email/request-change";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, RequestEmailChangeDto_1.RequestEmailChangeDtoToJSON)(requestParameters['requestEmailChangeDto']),
                            }];
                }
            });
        });
    };
    /**
     * Validates the target address, cancels any prior pending challenge, generates a hashed 6-digit OTP (10-minute TTL) and sends it to the new address via the email-otp-change template. Sets `users.pending_email` so subsequent `GET /v1/users/me` reflects the pending state. Uniqueness is enforced against both `email` and `pending_email` on other active users. Throttled to 3 requests per minute per client.
     * Start an email-change flow
     */
    UsersApi.prototype.emailRequestChangeControllerRequestChangeV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.emailRequestChangeControllerRequestChangeV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, RequestEmailChangeResponseDto_1.RequestEmailChangeResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Validates the target address, cancels any prior pending challenge, generates a hashed 6-digit OTP (10-minute TTL) and sends it to the new address via the email-otp-change template. Sets `users.pending_email` so subsequent `GET /v1/users/me` reflects the pending state. Uniqueness is enforced against both `email` and `pending_email` on other active users. Throttled to 3 requests per minute per client.
     * Start an email-change flow
     */
    UsersApi.prototype.emailRequestChangeControllerRequestChangeV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.emailRequestChangeControllerRequestChangeV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for languagePickerControllerGetSelectedV1 without sending the request
     */
    UsersApi.prototype.languagePickerControllerGetSelectedV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/language";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Fast single-record read for cold-start locale bootstrap — clients call this once on launch to set the app locale before rendering the picker.
     * Get the currently selected language
     */
    UsersApi.prototype.languagePickerControllerGetSelectedV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.languagePickerControllerGetSelectedV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SelectedLanguageDto_1.SelectedLanguageDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Fast single-record read for cold-start locale bootstrap — clients call this once on launch to set the app locale before rendering the picker.
     * Get the currently selected language
     */
    UsersApi.prototype.languagePickerControllerGetSelectedV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.languagePickerControllerGetSelectedV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for languagePickerControllerOptionsV1 without sending the request
     */
    UsersApi.prototype.languagePickerControllerOptionsV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/language/options";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Returns the full picker payload: languages grouped by `min_tier`, each with an `unlocked` flag derived from the caller plan. English and Hindi are on the Free tier; the Indic set is Pro.
     * List languages grouped by required tier
     */
    UsersApi.prototype.languagePickerControllerOptionsV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.languagePickerControllerOptionsV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, LanguageOptionsDto_1.LanguageOptionsDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the full picker payload: languages grouped by `min_tier`, each with an `unlocked` flag derived from the caller plan. English and Hindi are on the Free tier; the Indic set is Pro.
     * List languages grouped by required tier
     */
    UsersApi.prototype.languagePickerControllerOptionsV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.languagePickerControllerOptionsV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for languagePickerControllerUpdateV1 without sending the request
     */
    UsersApi.prototype.languagePickerControllerUpdateV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['updateLanguageDto'] == null) {
                            throw new runtime.RequiredError('updateLanguageDto', 'Required parameter "updateLanguageDto" was null or undefined when calling languagePickerControllerUpdateV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/language";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, UpdateLanguageDto_1.UpdateLanguageDtoToJSON)(requestParameters['updateLanguageDto']),
                            }];
                }
            });
        });
    };
    /**
     * Sets `user_settings.language_id` after enforcing `language.min_tier <= user.tier`. Already-generated content is not re-translated retroactively; it renders in whatever language it was produced in.
     * Update the selected language
     */
    UsersApi.prototype.languagePickerControllerUpdateV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.languagePickerControllerUpdateV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, SelectedLanguageDto_1.SelectedLanguageDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Sets `user_settings.language_id` after enforcing `language.min_tier <= user.tier`. Already-generated content is not re-translated retroactively; it renders in whatever language it was produced in.
     * Update the selected language
     */
    UsersApi.prototype.languagePickerControllerUpdateV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.languagePickerControllerUpdateV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for locationControllerUpdateV1 without sending the request
     */
    UsersApi.prototype.locationControllerUpdateV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['updateLocationDto'] == null) {
                            throw new runtime.RequiredError('updateLocationDto', 'Required parameter "updateLocationDto" was null or undefined when calling locationControllerUpdateV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/location";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, UpdateLocationDto_1.UpdateLocationDtoToJSON)(requestParameters['updateLocationDto']),
                            }];
                }
            });
        });
    };
    /**
     * Accepts lat/lng from the device GPS, resolves to an IANA timezone, stores the time_zone_id in user_settings, and records the change in user_timezone_history.
     * Update user timezone from GPS location
     */
    UsersApi.prototype.locationControllerUpdateV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.locationControllerUpdateV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, UpdateLocationResponseDto_1.UpdateLocationResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Accepts lat/lng from the device GPS, resolves to an IANA timezone, stores the time_zone_id in user_settings, and records the change in user_timezone_history.
     * Update user timezone from GPS location
     */
    UsersApi.prototype.locationControllerUpdateV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.locationControllerUpdateV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for phoneChangeControllerChangePhoneV1 without sending the request
     */
    UsersApi.prototype.phoneChangeControllerChangePhoneV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['changePhoneDto'] == null) {
                            throw new runtime.RequiredError('changePhoneDto', 'Required parameter "changePhoneDto" was null or undefined when calling phoneChangeControllerChangePhoneV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/phone";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, ChangePhoneDto_1.ChangePhoneDtoToJSON)(requestParameters['changePhoneDto']),
                            }];
                }
            });
        });
    };
    /**
     * Client verifies the new phone number via Firebase phone auth, then submits the resulting Firebase ID token here. Backend verifies the token, checks uniqueness against active users, updates users.phone, bumps token_version to invalidate outstanding refresh tokens, and returns a fresh JWT pair together with the updated profile.
     * Change the authenticated user phone number
     */
    UsersApi.prototype.phoneChangeControllerChangePhoneV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.phoneChangeControllerChangePhoneV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, ChangePhoneResponseDto_1.ChangePhoneResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Client verifies the new phone number via Firebase phone auth, then submits the resulting Firebase ID token here. Backend verifies the token, checks uniqueness against active users, updates users.phone, bumps token_version to invalidate outstanding refresh tokens, and returns a fresh JWT pair together with the updated profile.
     * Change the authenticated user phone number
     */
    UsersApi.prototype.phoneChangeControllerChangePhoneV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.phoneChangeControllerChangePhoneV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for phoneChangeControllerCheckPhoneV1 without sending the request
     */
    UsersApi.prototype.phoneChangeControllerCheckPhoneV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['checkPhoneChangeDto'] == null) {
                            throw new runtime.RequiredError('checkPhoneChangeDto', 'Required parameter "checkPhoneChangeDto" was null or undefined when calling phoneChangeControllerCheckPhoneV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/phone/check";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, CheckPhoneChangeDto_1.CheckPhoneChangeDtoToJSON)(requestParameters['checkPhoneChangeDto']),
                            }];
                }
            });
        });
    };
    /**
     * Validates the candidate E.164 number before the client triggers Firebase phone OTP. Rejects same-as-current and already-registered numbers so SMS is not spent on invalid targets. Confirm (`POST /v1/users/me/phone`) re-checks the same rules after OTP.
     * Check whether a phone number can be used for change-phone
     */
    UsersApi.prototype.phoneChangeControllerCheckPhoneV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.phoneChangeControllerCheckPhoneV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, CheckPhoneChangeResponseDto_1.CheckPhoneChangeResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Validates the candidate E.164 number before the client triggers Firebase phone OTP. Rejects same-as-current and already-registered numbers so SMS is not spent on invalid targets. Confirm (`POST /v1/users/me/phone`) re-checks the same rules after OTP.
     * Check whether a phone number can be used for change-phone
     */
    UsersApi.prototype.phoneChangeControllerCheckPhoneV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.phoneChangeControllerCheckPhoneV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for timezoneControllerOptionsV1 without sending the request
     */
    UsersApi.prototype.timezoneControllerOptionsV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['limit'] != null) {
                            queryParameters['limit'] = requestParameters['limit'];
                        }
                        if (requestParameters['q'] != null) {
                            queryParameters['q'] = requestParameters['q'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/timezone/options";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Returns active timezones sorted by UTC offset, then display name. `q` matches on display name, IANA name, and the offset label. `selectedId` and `defaultId` are echoed so the client can render the check-mark and the \"Default\" hint (default is derived from the user country).
     * Search/list active timezones
     */
    UsersApi.prototype.timezoneControllerOptionsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.timezoneControllerOptionsV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, TimezoneListDto_1.TimezoneListDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns active timezones sorted by UTC offset, then display name. `q` matches on display name, IANA name, and the offset label. `selectedId` and `defaultId` are echoed so the client can render the check-mark and the \"Default\" hint (default is derived from the user country).
     * Search/list active timezones
     */
    UsersApi.prototype.timezoneControllerOptionsV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.timezoneControllerOptionsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for timezoneControllerUpdateV1 without sending the request
     */
    UsersApi.prototype.timezoneControllerUpdateV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['updateTimezoneDto'] == null) {
                            throw new runtime.RequiredError('updateTimezoneDto', 'Required parameter "updateTimezoneDto" was null or undefined when calling timezoneControllerUpdateV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/users/me/timezone";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, UpdateTimezoneDto_1.UpdateTimezoneDtoToJSON)(requestParameters['updateTimezoneDto']),
                            }];
                }
            });
        });
    };
    /**
     * Flips `user_settings.auto_timezone_enabled` to false, sets the new override, and appends a `user_timezone_history` row with source `manual_override`. Digest scheduler picks up the new offset on the next planning cycle.
     * Update the user timezone override
     */
    UsersApi.prototype.timezoneControllerUpdateV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.timezoneControllerUpdateV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, UpdateTimezoneResponseDto_1.UpdateTimezoneResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Flips `user_settings.auto_timezone_enabled` to false, sets the new override, and appends a `user_timezone_history` row with source `manual_override`. Digest scheduler picks up the new offset on the next planning cycle.
     * Update the user timezone override
     */
    UsersApi.prototype.timezoneControllerUpdateV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.timezoneControllerUpdateV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for userSettingsControllerGetMySettingsV1 without sending the request
     */
    UsersApi.prototype.userSettingsControllerGetMySettingsV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/users/me/settings";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get current user settings including language
     */
    UsersApi.prototype.userSettingsControllerGetMySettingsV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userSettingsControllerGetMySettingsV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get current user settings including language
     */
    UsersApi.prototype.userSettingsControllerGetMySettingsV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userSettingsControllerGetMySettingsV1Raw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for userSettingsControllerPatchMySettingsV1 without sending the request
     */
    UsersApi.prototype.userSettingsControllerPatchMySettingsV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/users/me/settings";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'PATCH',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Update user settings including language preference
     */
    UsersApi.prototype.userSettingsControllerPatchMySettingsV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userSettingsControllerPatchMySettingsV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update user settings including language preference
     */
    UsersApi.prototype.userSettingsControllerPatchMySettingsV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userSettingsControllerPatchMySettingsV1Raw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for usersControllerDeleteMyAccountV1 without sending the request
     */
    UsersApi.prototype.usersControllerDeleteMyAccountV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/users/me";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'DELETE',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Schedule deletion of the current account (30-day grace period)
     */
    UsersApi.prototype.usersControllerDeleteMyAccountV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerDeleteMyAccountV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Schedule deletion of the current account (30-day grace period)
     */
    UsersApi.prototype.usersControllerDeleteMyAccountV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerDeleteMyAccountV1Raw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for usersControllerFindAllV1 without sending the request
     */
    UsersApi.prototype.usersControllerFindAllV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                if (requestParameters['page'] != null) {
                    queryParameters['page'] = requestParameters['page'];
                }
                if (requestParameters['pageSize'] != null) {
                    queryParameters['pageSize'] = requestParameters['pageSize'];
                }
                headerParameters = {};
                urlPath = "/v1/users";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * List all users with pagination
     */
    UsersApi.prototype.usersControllerFindAllV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerFindAllV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * List all users with pagination
     */
    UsersApi.prototype.usersControllerFindAllV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerFindAllV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for usersControllerFindByIdV1 without sending the request
     */
    UsersApi.prototype.usersControllerFindByIdV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['id'] == null) {
                    throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling usersControllerFindByIdV1().');
                }
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/users/{id}";
                urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get user by ID
     */
    UsersApi.prototype.usersControllerFindByIdV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerFindByIdV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get user by ID
     */
    UsersApi.prototype.usersControllerFindByIdV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerFindByIdV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for usersControllerGetMyProfileV1 without sending the request
     */
    UsersApi.prototype.usersControllerGetMyProfileV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/users/me";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'GET',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Get current user profile
     */
    UsersApi.prototype.usersControllerGetMyProfileV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerGetMyProfileV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get current user profile
     */
    UsersApi.prototype.usersControllerGetMyProfileV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerGetMyProfileV1Raw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for usersControllerRemoveV1 without sending the request
     */
    UsersApi.prototype.usersControllerRemoveV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['id'] == null) {
                    throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling usersControllerRemoveV1().');
                }
                queryParameters = {};
                headerParameters = {};
                urlPath = "/v1/users/{id}";
                urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'DELETE',
                        headers: headerParameters,
                        query: queryParameters,
                    }];
            });
        });
    };
    /**
     * Schedule deletion of a user (same 30-day grace as self-service)
     */
    UsersApi.prototype.usersControllerRemoveV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerRemoveV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Schedule deletion of a user (same 30-day grace as self-service)
     */
    UsersApi.prototype.usersControllerRemoveV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerRemoveV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates request options for usersControllerUpdateMyProfileV1 without sending the request
     */
    UsersApi.prototype.usersControllerUpdateMyProfileV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath;
            return __generator(this, function (_a) {
                if (requestParameters['updateUserDto'] == null) {
                    throw new runtime.RequiredError('updateUserDto', 'Required parameter "updateUserDto" was null or undefined when calling usersControllerUpdateMyProfileV1().');
                }
                queryParameters = {};
                headerParameters = {};
                headerParameters['Content-Type'] = 'application/json';
                urlPath = "/v1/users/me";
                return [2 /*return*/, {
                        path: urlPath,
                        method: 'PATCH',
                        headers: headerParameters,
                        query: queryParameters,
                        body: (0, UpdateUserDto_1.UpdateUserDtoToJSON)(requestParameters['updateUserDto']),
                    }];
            });
        });
    };
    /**
     * Update current user profile
     */
    UsersApi.prototype.usersControllerUpdateMyProfileV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerUpdateMyProfileV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update current user profile
     */
    UsersApi.prototype.usersControllerUpdateMyProfileV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usersControllerUpdateMyProfileV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return UsersApi;
}(runtime.BaseAPI));
exports.UsersApi = UsersApi;
